import React from 'react';
import Page from '../../components/Page';
import Rewards from './Rewards';
import Reward from './Reward';
import Paths from '../../constants/paths';
import { observer } from 'mobx-react-lite';
import { Route } from 'react-router-dom';
import NewReward from './NewReward';
import ErrorMessages from '../../components/ErrorMessages.js';

const RewardTab = ({ store }) => {
    return (
        <Page>
            <div style={{ marginLeft: '2.5%' }}>
                <ErrorMessages message={store.error} />
            </div>
            <Route exact path={Paths.REWARDS}>
                <Rewards store={store} />
            </Route>
            <Route exact path={Paths.REWARD}>
                <Reward store={store} />
            </Route>
            <Route exact path={Paths.NEW_REWARD}>
                <NewReward store={store} />
            </Route>
        </Page>
    );
};

export default observer(RewardTab);
